import clsx from "clsx";
import { useDispatch } from "react-redux";
import { Divider } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { PLAN_TYPE_NAMES } from "../../../consts/planTypes";
import { palette } from "../../../theme/palette";

import { setRouteWithTimeband } from "../../../reducers/ownApp/thunkActions";
import { addNotification } from "../../../reducers/ownApp";

import { View } from "../../View";
import { BaseSummaryPopover } from "../Base/BaseSummaryPopover";

const useStyles = makeStyles(() => ({
  routeLine: {
    fontWeight: "bold",
    color: palette.typography.black.solid,
  },
  labelContainer: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    width: "30px",
    height: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
    margin: "5px",
  },
  label: {
    margin: "2px",
    width: "26px",
    height: "26px",
    lineHeight: "26px",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
    position: "relative",
  },
  row: {
    display: "flex",
    lineHeight: "30px",
  },
  left: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
  },
  planType: {
    fontWeight: 400,
  },
  divider: {
    height: "1px",
    background: palette.typography.black.neutral,
  },
}));

const DriverlessRoutesPopover = ({
  driverlessRoutes,
  planType,
  open,
  anchorEl,
  onClose,
}) => {
  const styles = useStyles();
  const dispatch = useDispatch();

  const onClick = ({ type, route }) => {
    if (type === planType) {
      dispatch(setRouteWithTimeband(route));
      onClose();
    } else
      dispatch(
        addNotification({
          message: `Please switch to ${PLAN_TYPE_NAMES[type]} plan to allocate a driver.`,
          options: { variant: "info" },
        })
      );
  };

  return (
    <BaseSummaryPopover
      id={"driverlessRoutesPopover"}
      title={"Driverless Routes"}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      width={"160px"}
    >
      {driverlessRoutes.map(({ type, route }) => (
        <View key={route.routeCode}>
          <View className={clsx(styles.row, styles.routeLine)}>
            <View
              className={styles.left}
              onClick={() => onClick({ type, route })}
            >
              <div className={styles.labelContainer}>
                <div
                  style={{
                    background: route?.colour || "black",
                    color: route?.textColour || palette.typography.white.high,
                  }}
                  className={styles.label}
                >
                  {route.routeCode}
                </div>
              </div>
              {planType !== type && (
                <View className={styles.planType}>{PLAN_TYPE_NAMES[type]}</View>
              )}
            </View>
          </View>
          <Divider className={styles.divider} />
        </View>
      ))}
    </BaseSummaryPopover>
  );
};

export default DriverlessRoutesPopover;
